import { Route, Routes } from 'react-router-dom';
import { NotFound } from 'src/routes/NotFound';
import { ForgotPassword } from 'src/routes/public/Authentication/ForgotPassword/ForgotPassword';
import { ForgotPasswordSuccess } from 'src/routes/public/Authentication/ForgotPassword/ForgotPasswordSuccess';
import { LoginView } from 'src/routes/public/Authentication/Login/Login';
import { LinkAccount } from 'src/routes/public/Authentication/MigrateOrLinkAccount/LinkAccount';
import { MigrateAccount } from 'src/routes/public/Authentication/MigrateOrLinkAccount/MigrateAccount';
import { MigrationSuccess } from 'src/routes/public/Authentication/MigrateOrLinkAccount/MigrationSuccess';
import { SignUpSuccess } from 'src/routes/public/Authentication/SignUp/SignUpSuccess';
import { SetNewPassword } from './SetNewPassword/SetNewPassword';
import { SetNewPasswordSuccess } from './SetNewPassword/SetNewPasswordSuccess';
import { SignupView } from './SignUp/SignUp';

const AuthViews = () => (
    <Routes>
        <Route path="auth/login" element={<LoginView />} />
        <Route path="auth/forgot-password" element={<ForgotPassword />} />
        <Route path="auth/sign-up" element={<SignupView />} />
        <Route path="auth/migrate-account" element={<MigrateAccount />} />
        <Route path="auth/link-account" element={<LinkAccount />} />
        <Route path="auth/signup-success" element={<SignUpSuccess />} />
        <Route path="auth/migration-success" element={<MigrationSuccess />} />
        <Route path="auth/forgot-password-success" element={<ForgotPasswordSuccess />} />
        <Route path="auth/new-password" element={<SetNewPassword />} />
        <Route path="auth/new-password-success" element={<SetNewPasswordSuccess />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
);

export { AuthViews };
